import ColorScheme from '../ColorScheme/ColorScheme';

const Icon = ({ icon, fill, stroke, className }) => {
    const IconComponent = icon;
    if (!IconComponent) throw new Error('No icon provided');

    return (
        <IconComponent
            fill={fill || ColorScheme['sf-gray-500']}
            stroke={stroke}
            className={`box-content ${className}`}
        />
    );
};

export default Icon;
